import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

import { Link } from 'react-router-dom';
import colors from 'src/utils/colors';
import { getLoginContainerConfig } from 'src/components/SignIn/SignInContainer';
import { getAppName } from 'src/utils/app';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

const StyledTextField = styled(TextField)(() => ({
  marginTop: '12px',
  width: '100%',
  height: '48px',
  position: 'relative',

  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '999px',
    border: `1px solid ${colors.graysSecondary}`,
    pointerEvents: 'none',
    zIndex: 1
  },

  '& .MuiInputBase-root': {
    borderRadius: '999px',
    border: 'none',
    backgroundColor: '#fff',
    height: '48px',
    fontSize: '14px',
    position: 'relative',
    zIndex: 0
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: colors.grey,
    opacity: '0.5',
    height: '48px'
  },

  '.MuiInputBase-input': {
    height: '48px',
    fontFamily: 'Geist'
  },

  '& .MuiInputBase-input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px white inset',
    WebkitTextFillColor: '#000'
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
}));

const SignInInputField: React.FC<React.ComponentProps<typeof TextField> & { showForgotPassword?: boolean }> = ({
  showForgotPassword = false,
  label,
  sx,
  ...props
}) => {
  const appName = getAppName();
  const textColor = getLoginContainerConfig(appName).textColor;

  // Preserve referrer parameter when navigating to password reset
  const getPasswordResetUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get('referrer');
    const baseUrl = '/password_reset?step=inputEmail';
    return referrer ? `${baseUrl}&referrer=${referrer}` : baseUrl;
  };

  return (
    <Box sx={sx}>
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="self-end">
        {label ? (
          <Text variant="body2" sx={{ fontFamily: 'Geist', fontWeight: 500 }}>
            {label}
          </Text>
        ) : null}
        {showForgotPassword ? (
          <Link to={getPasswordResetUrl()}>
            <Text variant="body2" sx={{ fontFamily: 'Geist', fontWeight: 500, color: textColor }}>
              Forgot?
            </Text>
          </Link>
        ) : null}
      </Box>
      <StyledTextField {...props} />
    </Box>
  );
};

export default SignInInputField;
